import React, { useEffect, useState,useRef, useCallback } from 'react'
import './SHeader.css';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import { LoginService } from '../services/LoginService';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { fetchHeaderData, fetchProfileData, UploadImageData } from '../reduxactions/financeofficeractions/FOProfileActions';
import { Divider } from 'primereact/divider';
import { log } from 'console';
import eventBus from '../doctorapprover/eventBus';
type Nullable<T> = T | null;

var imageuser = require('../assets/img/medi.png');
var projecticon = require('../assets/img/medicaaal.png');
var defaultimage = require('../assets/img/images.png');


export const Fheader = () => {
  const op = useRef(null as any);
  const photos = window.sessionStorage.getItem('photo');
  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('');

  const imgSrc = imageuser;
  const dispatch = useDispatch();
  const usertype = window.sessionStorage.getItem('usertype');
  const username = window.sessionStorage.getItem('username');
  const [photo,setPhoto]=useState<any>(null);
    // useEffect(()=>{
    //   if(photos !== photo){
    //     // const photos = window.sessionStorage.getItem('photo');
    //     setPhoto(photos);
    //   }
    // },[setPhoto,photo,photos]);
    const fetchSessionPhoto = useCallback(async () => {
      try {
        const photoUrl = window.sessionStorage.getItem('photo');
        setPhoto(photoUrl);
      } catch (error) {
        console.error('Error fetching session photo:', error);
      }
    }, []);
    useEffect(() => {
      const handlePhotoUpdate = (newPhoto:any) => {
        setPhoto(newPhoto);
      };
      eventBus.on('photoUpdated', handlePhotoUpdate);
  
      return () => {
        eventBus.off('photoUpdated', handlePhotoUpdate);
      };
    }, []);
    
    useEffect(() => {
      fetchSessionPhoto();
    
      const handleStorageChange = () => {
        if (window.sessionStorage.getItem('photo') !== photo) {
          fetchSessionPhoto();
        }
      };
    
      window.addEventListener('storage', handleStorageChange);
    
      return () => {
        window.removeEventListener('storage', handleStorageChange);
      };
    }, [fetchSessionPhoto, photo]);
  console.log(photo,"head")
  
  

  const handleLogout = () => {
    window.sessionStorage.removeItem('usertype');
  };
  const data = useSelector((state: RootState) => state.fprofile.data);

  const [profile, setProfile] = useState<[]>([]);
  const getProfile = async() => {
    try {
      const payload = { uid: uid};
      const apiname = '/ws_an_get_finance_officer_profile.php';
      const data = await LoginService.getData(apiname, payload);
      setProfile(data);
  } catch (error) {

  }
  // getyear();
  };
  

  useEffectOnce(() => {
    getProfile();
}, []);

    const fetchDataAsync = async () => {
      try {
        await dispatch(fetchHeaderData(uid) as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    useEffectOnce(() => {
    fetchDataAsync();
  }, [dispatch]);



  return (

    <div className="layout-topbar" style={{ backgroundColor: 'rgb(40, 167, 69)', color: 'white', display: 'flex', alignItems: 'center' }}>
      <div className="layout-topbar-logo" style={{ flex: 1 }}>
        <span>
          <img src={imageuser} alt="Logo" width="50px" height="100%" />
          <img src={projecticon} alt="Logo" width="200px" height="100%" />
        </span>

      </div>


      {profile.map((response: any) =>
      <a className="nav-link" onClick={(e) => op.current.toggle(e)} style={{ textDecoration: 'none', marginLeft: '15px', float: 'right' }}>
        <img src={photo || defaultimage} className="avatar" alt="User Image" />
        <span className="hidden-xs" style={{ color: 'white', fontSize: '1.2rem', fontWeight: '400', fontFamily: 'Source Sans Pro, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif' ,marginLeft:'10px'}}>{username} - {usertype}</span>
      </a>
         )}



      <ul className="navbar-nav ml-auto">
        <OverlayPanel ref={op}>
          <div className="dropdown-divider"></div>
          <a className="dropdown-item" style={{ textDecoration: 'none' }}>
            <div className="media">
            <a href={`${process.env.PUBLIC_URL}/fprofile`} style={{ textDecoration: 'none' }}>Profile</a>
                <Divider />
                 {/* <a href={`${process.env.PUBLIC_URL}/vresetpassword`} style={{ textDecoration: 'none'}}>Reset Password</a> */}
              {/* <a href="/fprofile" style={{ textDecoration: 'none' }}>Profile</a>
              <Divider /> */}
              {/* <a href="/s" style={{textDecoration: 'none'}}>Reset Password</a> */}
              {/* <Divider /> */}
              <a href="/" style={{ textDecoration: 'none' }}>Sign out</a>
            </div>
          </a>
        </OverlayPanel>
      </ul>
    </div>



  );
};


Fheader.displayName = 'AppTopbar';

export default Fheader;
